import { GameV2Configuration } from '../common-types/ScreensConfigurations.type';

// Use generator to avoid reference issues on same object
export function getDefaultConfigurations (): GameV2Configuration {
  return {
    alreadyPlayed: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '',
      },
    },
    error: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '<span style="font-size:6vw;">Une erreur est survenue.</span>',
      },
    },
    game: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '',
      },
      plugin: {
        plugins: {
          armedBandit: {
            background: {
              color: '#01803F',
            },
            ctaButton: {
              background: {
                color: '#008540',
              },
              html: `
                <span style="font-size:3vw;">
                  <span style="font-family:tahoma,geneva,sans-serif;"><strong><span style="color:#FFFFFF;">JE JOUE</span></strong></span>
                </span>
              `,
            },
            loseImg: {
              imageUrl: 'https://statics.luckycart.com/design/intermarche/2gdhwq/images/game-page-background_1647522996846.jpg',
            },
            otherImg: {
              imageUrl: 'https://statics.luckycart.com/design/intermarche/2gdhwq/images/game-page-background_1647522996846.jpg',
            },
            winImg: {
              imageUrl: 'https://statics.luckycart.com/design/intermarche/2gdhwq/images/game-page-background_1647522993998.jpg',
            },
          },
          scratch: {
            background: {
              color: 'white',
            },
            ctaButton: {
              background: {
                color: 'white',
              },
              html: '<span style="font-size:6vw;">Lancer la roue !</span>',
            },
            stars: {
              color: 'white',
            },
          },
          wheel: {
            ctaButton: {
              background: {
                color: 'white',
              },
              html: '<span style="font-size:6vw;">Lancer la roue !</span>',
            },
            lose: {
              color: 'white',
              imageUrl: null,
            },
            win: {
              color: 'white',
              imageUrl: null,
            },
          },
        },
        type: 'wheel',
      },
    },
    home: {
      acceptTextBox: {
        html: '',
      },
      background: {
        color: 'white',
        imageUrl: null,
      },
      ctaButton: {
        background: {
          color: 'white',
          imageUrl: null,
        },
        html: '',
      },
      mainTextBox: {
        html: '',
      },
    },
    lost: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '',
      },
    },
    next: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      ctaButton: {
        background: {
          color: 'white',
          imageUrl: null,
        },
        html: '',
      },
      mainTextBox: {
        html: '',
      },
    },
    won: {
      background: {
        color: 'white',
        imageUrl: null,
      },
      mainTextBox: {
        html: '',
      },
    },
  };
}
